import React from "react";

const ChooseArticleView = () => {
  return (
    <div className="choose-article-view">
      Please select an Article from the list on the left.
    </div>
  );
};

export default ChooseArticleView;
